<template>
  <div>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>就诊患者画像</span>
            </div>

            <el-row :gutter="20" style="margin-top: 20px; margin-left: 20px">
              <el-col :span="4">
                <el-select v-model="selForm.sel_province" @change="get_city" placeholder="请选择省区">
                  <el-option v-for="item in options_province"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select v-model="selForm.sel_city" placeholder="请选择地办">
                  <el-option v-for="item in options_city"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-date-picker
                    v-model="selForm.date_span"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                </el-date-picker>
              </el-col>
              <el-col :span="5">
                <el-button type="primary" @click="query">查询</el-button>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-top: 20px;  ">
              <el-col :span="12">
                <el-card class="box-card" shadow="hover">
                  <div slot="header" class="clearfix">
                    <i class="el-icon-card-header-red"></i>
                    <span>就诊患者年龄分布</span>
                  </div>
                  <PieChart id="patient_age_pie"
                            :params="{'shengqu_name':this.selForm.sel_province,'diban_name':this.selForm.sel_city,'date_start':this.selForm.date_span[0],'date_end':this.selForm.date_span[1]}"
                            height="500px"
                            :key="this.change_flag"
                            width="100%"
                            path="patient_age_pie"></PieChart>
                </el-card>
              </el-col>
              <el-col :span="12">
                <el-card class="box-card" shadow="hover">
                  <div slot="header" class="clearfix">
                    <i class="el-icon-card-header-red"></i>
                    <span>就诊患者性别分布</span>
                  </div>
                  <PieChart id="patient_gender_pie"
                            :params="{'shengqu_name':this.selForm.sel_province,'diban_name':this.selForm.sel_city,'date_start':this.selForm.date_span[0],'date_end':this.selForm.date_span[1]}"
                            height="500px"
                            :key="this.change_flag"
                            width="100%"
                            path="patient_gender_pie"></PieChart>
                </el-card>
              </el-col>
            </el-row>

          </el-card>
        </div>
      </el-col>
    </el-row>

<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        <div class="grid-content bg-purple">-->
<!--          <el-card class="box-card" shadow="hover">-->
<!--            <div slot="header" class="clearfix" style="border: none">-->
<!--              <i class="el-icon-card-header"></i>-->
<!--              <span>诊所收入</span>-->
<!--            </div>-->
<!--            <ClinicBusinessFee prop_clinic_id="-1" prop_doctor_id="-1"></ClinicBusinessFee>-->
<!--          </el-card>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->

<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        <div class="grid-content bg-purple">-->
<!--          <el-card class="box-card" shadow="hover">-->
<!--            <div slot="header" class="clearfix" style="border: none">-->
<!--              <i class="el-icon-card-header"></i>-->
<!--              <span>诊所处方</span>-->
<!--            </div>-->
<!--            <ClinicBusinessCF prop_clinic_id="-1" prop_doctor_id="-1"></ClinicBusinessCF>-->
<!--          </el-card>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->


<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        <div class="grid-content bg-purple">-->
<!--          <el-card class="box-card" shadow="hover">-->
<!--            <div slot="header" class="clearfix" style="border: none">-->
<!--              <i class="el-icon-card-header"></i>-->
<!--              <span>医生统计</span>-->
<!--            </div>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="12">-->
<!--                <PieChart id="doctor_fees_pie"-->
<!--                          :params="{'clinic_id':'-1'}"-->
<!--                          height="300px"-->
<!--                          width="100%"-->
<!--                          path="doctor_fees_pie"></PieChart>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <PieChart id="doctor_cfl_pie"-->
<!--                          :params="{'clinic_id':'-1'}"-->
<!--                          height="300px"-->
<!--                          width="100%"-->
<!--                          path="doctor_cfl_pie"></PieChart>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-card>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->



<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        <div class="grid-content bg-purple">-->
<!--          <el-card class="box-card" shadow="hover">-->
<!--            <div slot="header" class="clearfix" style="border: none">-->
<!--              <i class="el-icon-card-header"></i>-->
<!--              <span>药物统计</span>-->
<!--            </div>-->
<!--            <el-row :gutter="20">-->
<!--              <el-col :span="12">-->
<!--                <PieChart id="clinic_drug_count_pie"-->
<!--                          :params="{'clinic_id':'-1'}"-->
<!--                          height="400px"-->
<!--                          width="100%"-->
<!--                          path="clinic_drug_count_pie"></PieChart>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <PieChart id="clinic_drug_fee_pie"-->
<!--                          :params="{'clinic_id':'-1'}"-->
<!--                          height="400px"-->
<!--                          width="100%"-->
<!--                          path="clinic_drug_fee_pie"></PieChart>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-card>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->



<!--    <el-row>-->
<!--      <el-col :span="24">-->
<!--        <div class="grid-content bg-purple">-->
<!--          <el-card class="box-card" shadow="hover">-->
<!--            <div slot="header" class="clearfix" style="border: none">-->
<!--              <i class="el-icon-card-header"></i>-->
<!--              <span>贴敷统计</span>-->
<!--            </div>-->

<!--            <el-row style="margin-top: 10px; margin-left: 550px;margin-bottom: 20px">-->
<!--              选择时间：<el-date-picker-->
<!--                v-model="date_value"-->
<!--                type="datetimerange"-->
<!--                :picker-options="pickerOptions"-->
<!--                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                range-separator="至"-->
<!--                start-placeholder="开始日期"-->
<!--                end-placeholder="结束日期"-->
<!--                align="right">-->
<!--            </el-date-picker>-->
<!--            </el-row>-->

<!--            <el-row  :gutter="10">-->
<!--              <el-col :span="12">-->
<!--                <LineChart id="tfcf_trend" path="tfcf_trend" height="300px" width="100%" :key="date_value"-->
<!--                           :params='{"clinic_id":"-1","date_start":date_value[0],"date_end":date_value[1]}'>-->

<!--                </LineChart>-->
<!--              </el-col>-->
<!--              <el-col :span="12">-->
<!--                <LineChart id="xzztt_trend" path="xzztt_trend" height="300px"  width="100%" :key="date_value"-->
<!--                           :params='{"clinic_id":"-1","date_start":date_value[0],"date_end":date_value[1]}'>-->
<!--                </LineChart>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-card>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->

  </div>
</template>

<script>
import moment from "moment-timezone";
import PieChart from "@/views/charts/pie";
// import ClinicBusinessFee from "@/views/clinic/ClinicBusinessFee";
// import ClinicBusinessCF from "@/views/clinic/ClinicBusinessCF";


export default {
  name: "GlobalProfile",
  mounted() {
    this.get_province();
  },
  components: {
    PieChart,
    // ClinicBusinessFee,
    // ClinicBusinessCF,
  },
  methods: {
    query() {
      this.change_flag = new Date().getSeconds()
    },
    get_province() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        this.options_province = res.data.data
      })
    },
    get_city() {
      this.selForm.sel_city = ''
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_diban?province_id=" + this.selForm.sel_province).then((res) => {
        this.options_city = res.data.data
      })
    },
  },
  data() {
    return {
      date_value: [moment().subtract(30, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      selForm: {
        date_span: [moment().subtract(365, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
        sel_province: '',
        sel_city: '',
        sel_dim: '',
        sel_diag: '',
      },
      change_flag: 0,
      options_province: null,
      options_city: null,
      selKey: "",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
}
</script>

<style scoped>
.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>
